import * as firebase from 'firebase/app';
import * as Noty from 'noty';
import 'firebase/auth';
import 'firebase/storage';
import httpResource from "../../../core/infrastructure/httpResource";
import authClaimsRepository from "../repositories/AuthClaimsRepository";
// import UserAgent from '../../../uq-ui/helpers/express-useragent';

const config = {
  "apiKey": process.env.REACT_APP_FB_API_KEY,
  "authDomain": process.env.REACT_APP_FB_AUTH_DOMAIN,
  "databaseURL": process.env.REACT_APP_FB_DATABASE_URL,
  "projectId": process.env.REACT_APP_FB_PROJECT_ID,
  "storageBucket": process.env.REACT_APP_FB_STORAGE_BUCKET,
  "messagingSenderId": process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
  "appId": process.env.REACT_APP_FB_APP_ID,
  "measurementId": process.env.REACT_APP_FB_MEASUREMENT_ID
};

console.log('server:api', process.env.API_URI);
console.log('firebase:config', config);

class AuthService {
  private auth;
  private fbProvider;
  private googleProvider;
  // private userAgent;
  private _headerTokenSubscription: any = null;

  constructor() {
    firebase.initializeApp(config);
    this.auth = firebase.auth();
    this.fbProvider = new firebase.auth.FacebookAuthProvider();
    this.googleProvider = new firebase.auth.GoogleAuthProvider();
    // this.userAgent = new UserAgent().parse(navigator.userAgent);
    // this.fbProvider.setCustomParameters({ 'display': 'popup' });
  }

  public onAuthStateChanged(callback) {
    return this.auth.onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        this.setAuthTokenInHeaders(token);
        if (!user.isAnonymous) {
          let result = await this._checkClaimsAndLoadUserInfo()
            .catch((error) => {
              this._handleClaimsError(error);
              new Noty({
                type: 'error',
                timeout: 3000,
                text: 'Session claims load failed',
              }).show();
              callback(null);
            });
          const userInfo = result.entity;
          if (userInfo) {
            this._createTokenObservable();
            callback({ user, info: userInfo, isNew: result.is_new });
          } else {
            callback(null);
          }
        } else {
          callback({ user });
        }
      } else {
        callback(null);
      }
    });
  }

  public signInWithEmail = ({ email, password }) => {
    return this.auth.signInWithEmailAndPassword(email, password);
  };

  public fetchSignInMethodsForEmail = (email) => {
    return this.auth.fetchSignInMethodsForEmail(email);
  };

  public sendPasswordResetEmail = (email, actionCodeSettings) => {
    return this.auth.sendPasswordResetEmail(email, actionCodeSettings);
  };

  public signInAnonymously = () => {
    return this.auth.signInAnonymously().then((userCredential: firebase.auth.UserCredential) => {
      if (userCredential.user) {
        return userCredential.user.getIdToken()
        .then((token) => { 
          this.setAuthTokenInHeaders(token); 
          return userCredential; 
        });
      } 
      return userCredential;
    })
  };

  public registerWithEmail = ({ email, password }) => {
    return this.auth.createUserWithEmailAndPassword(email, password);
  };

  public logout() {
    return this.auth.signOut();
  }

  public signInWithFacebook() {
    return this.signInSocial(this.fbProvider);
  }

  public signWithGoogle() {
    return this.signInSocial(this.googleProvider);
  }

  private signInSocial(socialProvider): Promise<void> {
    return this.auth.signInWithPopup(socialProvider);
    // if (this.userAgent.isDesktop) return this.auth.signInWithPopup(socialProvider);
    // else return this.auth.signInWithRedirect(socialProvider);
  } 

  public getRedirectResult() {
    return this.auth.getRedirectResult();
  }

  private _createTokenObservable() {
    if (this._headerTokenSubscription) {
      this._headerTokenSubscription();
    }
    this._headerTokenSubscription = firebase.auth().onIdTokenChanged((user) => {
      user && user.getIdToken().then((token) => this.setAuthTokenInHeaders(token));
    });
  }

  public setAuthTokenInHeaders(token) {
    httpResource.setHeaders({ Authorization: token });
  }

  private _checkClaimsAndLoadUserInfo() {
    return authClaimsRepository.create({ entity_type: 'USER' });
  }

  public sendEmailVerification() {
    return authClaimsRepository.sendVerification();
  }

  private _handleClaimsError(error) {
    if (error && typeof error.json === 'function') {
      error.json().then((body) => {
        if (body.code === 'ALREADY_REGISTERED_AS_ANOTHER_TYPE') {
          // todo handle error
        }
      });
    } else {
      // todo
    }
  }
}

const authService = new AuthService();

export default authService;


// WEBPACK FOOTER //
// ./src/app/modules/auth/domain/services/AuthService.ts